import styles from './Checkbox.module.scss';

export const SIZE = {
  S: 20,
  M: 24,
  L: 28,
} as const;

export type CheckboxSize = (typeof SIZE)[keyof typeof SIZE];

export const ICON_SIZE_MAP: Record<CheckboxSize, number> = {
  [20]: 12,
  [24]: 16,
  [28]: 20,
};

export const SIZE_CLASS_MAP: Record<CheckboxSize, string> = {
  [20]: styles.size20!,
  [24]: styles.size24!,
  [28]: styles.size28!,
};
